export default class Analytics {

    //Unique identifiers relating to this particular browser/session
    SessionID = "";
    UID = "";

    //The analytics data
    BaseUrl: string;
    ClientId: string;
    AppId: string;

    constructor(baseUrl: string, clientId: string, appId: string) {

        this.BaseUrl = baseUrl;
        this.ClientId = clientId;
        this.AppId = appId;

        //Force to https - https is needed for GUID etc
        if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
            location.replace(`https:${location.href.substring(location.protocol.length)}`);
            return; //abort
        }

        //Generate a new session ID every single time
        this.SessionID = this.RequestUUID();

        //Get a previous UID from the browser
        this.UID = localStorage.getItem("uid") ?? "";
        if (!this.UID) {
            this.UID = this.RequestUUID();
            localStorage.setItem("uid", this.UID);
        }

    }

    RequestUUID(): string {
        return crypto.randomUUID();
    }

    Post(category: string, action: string, value: number, labels: string[] = [], otherData: { [key: string]: string } = {}): Promise<void> {

        return new Promise<void>((resolve, reject) => {

            const url = this.BaseUrl + "Event/" + this.ClientId + "/" + this.AppId + "/" + category + "/" + action;

            const date = new Date();

            const year = "" + date.getFullYear();
            let month = "" + (date.getMonth() + 1);
            let day = "" + (date.getDate());

            while (month.length < 2) {
                month = "0" + month;
            }
            while (day.length < 2) {
                day = "0" + day;
            }

            const data: { [key: string]: any } = {
                OS: detectOS(),
                Platform: navigator.userAgent,
                Date: parseInt(year + month + day, 10), //Force to number
                Value: value,
                UID: this.UID,
                sessionID: this.SessionID,
                URL: location.href,
                Timestamp: new Date(),
            }

            //Patch in the label data
            for (let i = 0; i < labels.length; i++) {
                data["Label" + (i + 1)] = labels[i];
            }

            fetch(url, {

                method: "POST",
                cache: "no-cache",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ ...data, ...otherData })

            }).finally(() => {

                //Never bother retrying analytics
                resolve();

            })

        });
    }

}

function iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

//https://tecadmin.net/javascript-detect-os/
function detectOS() {

    const userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];

    let os: null | string = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1 || iOS()) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}
